<template>
    <div class="container login-container">
        <b-overlay :show="showoverlay" class="h-100" rounded="sm">
        <div class="d-flex justify-content-center align-items-center flex-column login-page-main-wrapper">
            <div class="row justify-content-center login-form-wrapper">
                <div class="col-md-7 login-right d-flex align-items-center rounded-right" v-if="showReset">
                    <div class="users-style">
                        <template v-if="hostname != 'secure.accordhrm.com'">
                            <span class="vendor-logo-wrapper">
                                <img :src="$api_url+'/images/landing-page/'+replaceDotWithUnerscore(hostname)+'.png'" class="brac-bank-logo" :alt="hostname">
                            </span>
                        </template>
                        <p class="text-center mb-0 login-title">Reset <span class="light-green-text">Password</span></p>
                        <p class="text-center" style="font-size: 14px; color: rgba(0, 28, 56, 1); margin: 30px 0;">Forgot your password? Enter the email address linked to your account and we will send you a link to reset it!</p>
                        <b-form @submit.stop.prevent="onSubmit">
                            <b-form-group id="email-group" label="Email / Phone Number" label-for="email">
                                <b-form-input id="email" name="email" placeholder="" v-model="fdata.email" v-validate="{ required: true, min: 3}" :state="validateState('email')" aria-describedby="email-feedback" data-vv-as="Email/Phone"></b-form-input>
                                <b-form-invalid-feedback id="email-feedback">{{ veeErrors.first('email') }}</b-form-invalid-feedback>
                            </b-form-group>
                            
                            <b-form-group class="mb-3">
                                <vue-recaptcha
                                    ref="recaptcha"
                                    @verify="onVerify"
                                    @expired="onExpired"
                                    :sitekey="sitekey" :loadRecaptchaScript=true>
                                    </vue-recaptcha>    
                            
                            </b-form-group>

                            <p class="text-right pt-3" style="font-size: 12px; color: rgba(0, 28, 56, 1);">Go Back to <a type="link" variant="primary" style="font-size: 12px; color: rgba(0, 28, 56, 1); font-weight: 600;" :href="this.$api_url">Login Page</a></p>
                            
                            <b-form-group>
                                <b-button type="submit" variant="primary" class="login-btn login-form-submit-btn mt-5 emp-login-btn"  style="width: 260px;">Send Reset Link</b-button>
                            </b-form-group>
                        </b-form>
                    </div>
                </div>
                <div class="col-md-7 login-right d-flex align-items-center rounded-right" v-else>
                    <div class="users-style" v-if="showResetPass">
                        <template v-if="hostname != 'secure.accordhrm.com'">
                            <span class="vendor-logo-wrapper">
                                <img :src="$api_url+'/images/landing-page/'+replaceDotWithUnerscore(hostname)+'.png'" class="brac-bank-logo" :alt="hostname">
                            </span>
                        </template>
                        <p class="text-center mb-0 login-title">Set <span class="light-green-text">Password</span></p>
                        <b-form-group id="password-group" label="New Password" label-for="password">
                            <b-form-input id="password" name="password" placeholder="" type="password" v-model="rdata.password" v-validate="{ required: true, min: 8 }" :state="validateState('password')" aria-describedby="password-feedback" data-vv-as="Password"></b-form-input>
                            <b-form-invalid-feedback id="password-feedback">{{ veeErrors.first('password') }}</b-form-invalid-feedback>
                            <p style="color: #5B5E63; font-weight: 400; font-size: 9px;" class="mb-3 mt-2 text-left">Use 8 or more characters with a mix of letters, numbers &amp; symbols.</p>
                        </b-form-group>

                        <b-form-group id="password_confirmation-group" label="Confirm Password" label-for="password_confirmation" >
                            <b-form-input id="password_confirmation" name="password_confirmation" placeholder="" type="password" autocomplete="off" v-model="rdata.password_confirmation" v-validate="{ required: true, confirmed: rdata.password }" :state="validateState('password_confirmation')" aria-describedby="password_confirmation-feedback" data-vv-as="Confirm Password"></b-form-input>
                            <b-form-invalid-feedback id="password_confirmation-feedback">{{ veeErrors.first('password_confirmation') }}</b-form-invalid-feedback>
                        </b-form-group>


                        <b-form-group>
                            <b-button type="submit" variant="primary" class="login-btn login-form-submit-btn mt-5 emp-login-btn" @click="setPass()" style="width: 260px;">Set Password</b-button>
                        </b-form-group>
                        
                    </div>

                    <div class="users-style" v-else>
                        <template v-if="hostname != 'secure.accordhrm.com'">
                            <span class="vendor-logo-wrapper">
                                <img :src="$api_url+'/images/landing-page/'+replaceDotWithUnerscore(hostname)+'.png'" class="brac-bank-logo" :alt="hostname">
                            </span>
                        </template>
                        <p class="text-center mb-0 login-title">Verification<span class="light-green-text"></span></p>
                        <p class="text-center" style="font-size: 14px; color: rgba(0, 28, 56, 1); margin: 30px 0;">We have sent you a six digit verification code to your registered email/phone number. In order to finish resetting your password, please enter the code below.</p>
                        <b-form-group id="forget_pass_code-group" label="Verification Code" label-for="forget_pass_code">
                            <b-form-input id="forget_pass_code" name="forget_pass_code" placeholder="" v-model="forget_pass_code" v-validate="{ required: true}" :state="validateState('forget_pass_code')" aria-describedby="forget_pass_code-feedback" data-vv-as="Verification Code"></b-form-input>
                            <b-form-invalid-feedback id="forget_pass_code-feedback">{{ veeErrors.first('forget_pass_code') }}</b-form-invalid-feedback>
                        </b-form-group>
                        <p class="text-right pt-3" style="font-size: 12px; color: rgba(0, 28, 56, 1);">Go Back to <a type="link" variant="primary" style="font-size: 12px; color: rgba(0, 28, 56, 1); font-weight: 600;" :href="this.$api_url">Login Page</a></p>
                        <b-form-group>
                            <b-button type="submit" variant="primary" class="login-btn login-form-submit-btn mt-5 emp-login-btn" @click="verify()" style="width: 260px;">Verify</b-button>
                        </b-form-group>                    
                    </div>
                </div>
                <div class="col-md-6 login-left d-flex align-items-center position-relative">
                    <img v-bind:src="$api_url+'/images/landing-page/Abstract-Background.png'" class="login-landing-image lgn-mgt" v-if="step == 0">
                    <img v-bind:src="$api_url+'/images/landing-page/Abstract-Background.png'" class="login-landing-image lgn-emp" v-else>
                    <div class="login-left-content-wrapper">
                        <div class="accord-link text-right"><a class='atl-hr-link font-semi-bold' href="https://accordhrm.com/" target="_blank">www.accordhrm.com</a></div>
                        <div class="accord-branding-wrapper text-right">
                            <p>Welcome to</p> 
                            <img  :src="$api_url+'/images/landing-page/logo-white.png'" class="bkash-landing-image">
                        </div>
                        <p class="landing-page-intro-text">HR & Payroll solutions to suit your business</p>
                        <div class="row">
                            <div class="col-md-7">
                                <p class="d-block"><a href="tel:+880-1711-314600"><b-icon icon="telephone-fill" class="mr-1"></b-icon><span class="font-light">+880-1711-314600</span></a></p>
                                <p><a href="mailto:info@accordhrm.com"><b-icon icon="envelope-fill" class="mr-1"></b-icon><span class="font-light">info@accordhrm.com</span></a></p>
                            </div>
                            <div class="col-md-5 d-flex align-items-center justify-content-end">
                                <ul class="p-0 m-0 footer-social-icons">
                                    <li class="mr-2"><a target="_blank" href="https://www.facebook.com/accordhrm"><img  :src="$api_url+'/images/landing-page/landing-Facebook.png'" class="bkash-landing-image"></a></li>
                                    <li class="mr-2"><a target="_blank" href="https://www.linkedin.com/company/accordhrm/"><img  :src="$api_url+'/images/landing-page/landing-Linkedin.png'" class="bkash-landing-image"></a></li>
                                    <li class="mr-2"><a target="_blank" href="https://www.youtube.com/@accordhrm"><b-icon icon="youtube"></b-icon></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </b-overlay>
    </div>    
    
</template> 
<script>
    import VueRecaptcha from 'vue-recaptcha';
    export default{
        
        mounted() {
            
        },
        components: {
            'vue-recaptcha': VueRecaptcha,
        },
        data(){            
            
            return {
                                   
                successmsg:'',
                errormsg:[],
                fdata: {email: null},
                rdata: {password:null , password_confirmation:null},

                showReset : true,
                showResetPass : false,
                forget_pass_code : null,

                showoverlay : false,

                //showReset : false,
                //showResetPass : true,

                //show_captcha : false,
                captcha_verify : false,
                //sitekey: '6LdOYzsbAAAAAOvXGo3cpT1A_m6dsYEEcLczJMCa',
                sitekey: '6Leg2jMqAAAAAD_UnKTKkLpPof4VETXi8nBo7nU0',

                hostname: window.location.hostname,
                
            }
        },
        methods:{
            onVerify: function (response) {
                //console.log('Verify: ' + response);
                this.captcha_verify = true;

            },
            onExpired: function () {
                //console.log('Expired')
                this.captcha_verify = false;
            },
            resetRecaptcha() {
                this.$refs.recaptcha.reset(); // Direct call reset method
                
            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetvalidator()
            {
                 this.$validator.reset();
            },
            validateEmail(email) 
            {
                var re = /\S+@\S+\.\S+/;
                return re.test(email);
            },
            resetForm()
            {
                this.fdata = {
                    
                    //asd:null,
                };

                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            verify()
            {
                let currentObj = this;
                this.$bvToast.hide();

                let submitUrl = this.$api_url + '/employee/reset/verify';

                let formData = new FormData();
                
                formData.append('forget_pass_code', this.forget_pass_code);

                axios.post(submitUrl, formData)
                                .then(function (response) 
                                {
                                    
                                    if(response.data.status == 1)
                                    {
                                        /* currentObj.$bvToast.toast('Successfully Verified!', {
                                            title: `Info`,
                                            variant: 'info',
                                            solid: true,
                                            noAutoHide:true,
                                            toaster: 'b-toaster-top-center',
                                        }); */
                                        
                                        this.showResetPass = true;

                                        this.$validator.reset();
                                    }
                                    else
                                    {
                                        currentObj.$bvToast.toast('Wrong verification code', {
                                            title: `Warning`,
                                            variant: 'warning',
                                            solid: true,
                                            noAutoHide:true,
                                            toaster: 'b-toaster-top-center',
                                        });
                                        
                                    }
                                    
                                }.bind(this))
                                .catch(function (error){ currentObj.serverError(error); });

            },
            setPass()
            {
                if(!this.checkNet()) return false;

                this.$bvToast.hide();

                this.$validator.validateAll().then(result => {
                    if (!result) {
                        //return;
                    }

                    //alert('hi..');

                    let submitUrl = this.$api_url + '/employee/reset/password';
                    
                    let currentObj = this;
                    let formData = new FormData();                    
                    formData.append('password', this.rdata.password);

                    axios.post(submitUrl, formData)
                                .then(function (response) 
                                {
                                   
                                    if(response.data.status == 1)
                                    {
                                        currentObj.$bvToast.toast('Password Reset Done.', {
                                            title: `Info`,
                                            variant: 'info',
                                            solid: true,
                                            noAutoHide:true,
                                            toaster: 'b-toaster-top-center',
                                        });

                                        //window.location.href = this.$api_url;
                                        setTimeout("location.href = '"+this.$api_url+"';",1500);
                                    }
                                    else
                                    {
                                        currentObj.$bvToast.toast('No employee found with given email/phone number.', {
                                            title: `Error`,
                                            variant: 'danger',
                                            solid: true,
                                            noAutoHide:true,
                                            toaster: 'b-toaster-top-center',
                                        }); 
                                        
                                    }
                                    
                                }.bind(this))
                                .catch(function (error) 
                                {
                                    currentObj.serverError(error);
                                });
                });
            },
            onSubmit(e) 
            {
                if(!this.checkNet()) return false;
                this.$bvToast.hide();

                if(this.captcha_verify == false) 
                {
                    this.$bvToast.toast('Sorry but you must fill in the CAPTCHA below to complete the procedure.', {
                                            title: `Warning`,
                                            variant: 'warning',
                                            solid: true,
                                            noAutoHide:true,
                                            toaster: 'b-toaster-top-center',
                                        }); 
                    return false;
                }

                let submitUrl = '';
                let auth_with = 'phone number';

                if(this.validateEmail(this.fdata.email))
                {                    
                    auth_with = 'email address';
                    submitUrl = this.$api_url + '/employee/reset?f=1';
                }
                    
                else if(isNaN(this.fdata.email) === false)
                    submitUrl = this.$api_url + '/employee/reset';
                else
                {
                    alert('Wrong Email/Phone number');
                    return false;
                }      

                this.showoverlay = true;              

                
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    e.preventDefault();  
                    let currentObj = this;

                    let formData = new FormData();
                    
                    for (let [key, value] of Object.entries(this.fdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);                    
                        
                    } 

                    axios.post(submitUrl, formData)
                                .then(function (response) 
                                {
                                   
                                    if(response.data.status == 1)
                                    {
                                        this.showReset = false;
                                        this.showoverlay = false;                                        
                                    
                                        /* currentObj.$bvToast.toast('A six digit verification code has been sent to the specified ' + auth_with + '. To finish resetting your password, enter the verification code below.', {
                                            title: `Info`,
                                            variant: 'info',
                                            solid: true,
                                            noAutoHide:true,
                                            toaster: 'b-toaster-top-center',
                                        });  */
                                    
                                    }
                                    else
                                    {
                                        currentObj.$bvToast.toast('Sorry, no employee found with the specified ' + auth_with + ' or the user is already logged in.', {
                                            title: `Error`,
                                            variant: 'danger',
                                            solid: true,
                                            noAutoHide:true,
                                            toaster: 'b-toaster-top-center',
                                        }); 

                                        
                                        this.captcha_verify = false;
                                        this.resetRecaptcha();
                                        this.showoverlay = false;
                                        
                                    }
                                    
                                }.bind(this))
                                .catch(function (error) 
                                {
                                    currentObj.serverError(error);
                                    this.showoverlay = false;
                                });

                        
                });
            },            

        },
        created: function(){
            //
        }
    }
</script>
